import { useFetchCharts, useFetchAiCredits } from "../Services/query"

export const StateDashboard = ({ startDate, endDate } = {}) => {
    const { data: charts } = useFetchCharts()
    const { data: aiCredits } = useFetchAiCredits({ startDate, endDate })
    return {
        charts,
        aiCredits
    }
}